module.exports = __webpack_public_path__ + "assets/img/left-title-open-2b9a9be3.png";